import { ImagePlus, LayoutGrid, LayoutTemplate, Layers, Shapes, SlidersHorizontal, Sparkles, Type } from 'lucide-react';

import { SIDE_PANELS } from '../../config';

export const INSPECTOR_TAB = 'inspector';

export const TAB_META = {
  [INSPECTOR_TAB]: { icon: SlidersHorizontal, labelKey: 'inspector' },
  [SIDE_PANELS.LAYERS]: { icon: Layers, labelKey: 'panelLayers' },
  [SIDE_PANELS.FORMATS]: { icon: LayoutTemplate, labelKey: 'panelFormats' },
  [SIDE_PANELS.TEXT]: { icon: Type, labelKey: 'panelText' },
  [SIDE_PANELS.ELEMENTS]: { icon: Shapes, labelKey: 'panelElements' },
  [SIDE_PANELS.UPLOAD]: { icon: ImagePlus, labelKey: 'panelUpload' },
  [SIDE_PANELS.TEMPLATES]: { icon: LayoutGrid, labelKey: 'panelTemplates', isComingSoon: true },
  [SIDE_PANELS.AI_LABELS]: { icon: Sparkles, labelKey: 'panelAiLabels' },
};

export const PANEL_FEATURES = {
  [SIDE_PANELS.LAYERS]: (features) => features.layersPanel,
  [SIDE_PANELS.FORMATS]: (features) => features.formatPresets,
  [SIDE_PANELS.TEXT]: (features) => features.text,
  [SIDE_PANELS.ELEMENTS]: (features) => features.shapes,
  [SIDE_PANELS.UPLOAD]: (features) => features.openImage || features.addLayer,
  [SIDE_PANELS.AI_LABELS]: (features) => features.aiLabels,
};
